import { Box, Container } from "@sembark-travel/ui-base"
import { Breadcrumbs } from "@sembark-travel/ui-router"
import { showSnackbar } from "@sembark-travel/ui-snackbar"
import { useXHR } from "@sembark-travel/xhr"
import { Helmet } from "react-helmet-async"
import {
	NewAxisRoomsIntegrationForm,
	TIntegration,
} from "../../../../Integrations"
import { generatePath, useNavigate } from "../../../../router-utils"

export default function NewAxisRoomsIntegrationPage() {
	const xhr = useXHR()
	const navigate = useNavigate()

	return (
		<>
			<Helmet>
				<title>New AxisRooms Integration</title>
			</Helmet>
			<Breadcrumbs
				title="New AxisRooms Integration"
				items={[
					[generatePath("/org/integrations"), "Integrations"],
					[generatePath("/integrations/new"), "New"],
					["", "AxisRooms Channel Manager"],
				]}
			/>
			<Box paddingX={{ md: "4" }} paddingY={{ md: "8" }}>
				<Box maxWidth="6xl" marginX="auto">
					<Box borderWidth={{ md: "1" }} rounded="md" bgColor="default">
						<Container paddingY="6">
							<NewAxisRoomsIntegrationForm
								initialValues={{
									name: "AxisRooms",
									description:
										"Sync rates, inventory and restrictions with the AxisRooms channel manager",
								}}
								onSubmit={async (values) => {
									const integration = await xhr
										.post<{ data: TIntegration }>("integrations", { ...values })
										.then((resp) => resp.data.data)
									showSnackbar("Integration created successfully.")
									navigate("/integrations/:integrationId", {
										params: { integrationId: String(integration.uid) },
										replace: true,
									})
								}}
								onCancel={() => {
									navigate("/org/integrations", { replace: true })
								}}
							/>
						</Container>
					</Box>
				</Box>
			</Box>
		</>
	)
}
